/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ApiBroadcastOnStrymeGet$Params {
  broadcastKey?: string;
  message?: string;
}

export function apiBroadcastOnStrymeGet(http: HttpClient, rootUrl: string, params?: ApiBroadcastOnStrymeGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiBroadcastOnStrymeGet.PATH, 'get');
  if (params) {
    rb.query('broadcastKey', params.broadcastKey, {});
    rb.query('message', params.message, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiBroadcastOnStrymeGet.PATH = '/api/Broadcast/on-stryme';
